<!-- 2022 摄影专题-->
<template>
<div class="phone">
    <SimpleHead />
    <TopBanner :banner="banner" />
    <div class="warrp800">
        <GoodShop />
        <JoinStyle />
        <!--类型选择-->
        <div class="tab-style" >
            <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选</div>
            <div class="item" :class="{active:type==1}" @click="typeChange(1)">点赞最多</div>
            <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
        </div>

        <!---列表展示-->
        <div class="post-list" v-if="list.length>0" id="third-floor">
            <div class="iner-warp">
                <template v-for="(item,index) in list" >
                    <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index" class="mrg-btm20"></YorkbbsInfoflowItem>
                    <ItemSubject v-else :data="item" :key="item.id" />
                </template>

                 <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
            </div>
            
           
        </div>
        <!--操作按钮-->
        <div class="join-play">
            <div class="box">
                <a :href="'/publish/travel?subject=7db7510f-ecd1-44db-86ed-345de3f78537'|hostBuild('forum')" target="_blank"><div><i class="yk yk-camera"></i></div> 上传照片/视频晒秋天</a>
            </div>
            
            <a class="media-box" :href="'/publish/travel?subject=7db7510f-ecd1-44db-86ed-345de3f78537'|hostBuild('forum')" target="_blank">
            
                <div>上传</div>
                <div>照片/视频</div>
            </a>
          
        </div>
        <div style="height:100px" class="white-space"></div>
        <CssFooter></CssFooter> 
        
    </div>
    <RightFixed />
</div>
</template>
<script>
import SimpleHead from '@/components/widgets/simple-head.vue'
import TopBanner from '@/components/widgets/top-banner.vue'
import GoodShop from './good-shop.vue'
import JoinStyle from './join-style.vue'
import { throttle } from 'throttle-debounce';
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import ItemSubject from './item-subject.vue'
import CssFooter from '@/components/css-footer.vue'
import RightFixed from './right-fixed.vue'
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
export default {
    name:'Photo2022',
    components:{TopBanner,GoodShop,JoinStyle,CssFooter,ItemSubject,RightFixed,SimpleHead,YorkbbsInfoflowItem},
    data(){
        return {
            banner:{
                pcBanner:'https://media5.imgyb.xyz/media/v1/image/762b1ba17478206fdb56a23453a459f2.png',
                pcBannerBg:'https://media6.imgyb.xyz/media/v1/image/047e555f58e21e7a17b69402ff2c9d6c.png',
                mBanner:'https://media1.imgyb.xyz/media/v1/image/490d30a2615fafac5c43e355e2a40ec2.png',
                
            },
            type:0,
            params:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                "sort":['property_top: DESC','property_commentedAt: DESC'],
                "subject": [
                    "7db7510f-ecd1-44db-86ed-345de3f78537"
                ],
                "options":{"elite":[1]},    
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:true,
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        shareFun(){
            if( window.navigator.canShare && window.navigator.canShare({url:window.location.origin})){
                navigator.share({
                    title:'这个是title',
                    text:'这个是text字段，看有什么用',
                    url:window.location.origin,
                //text:'这个是text字段，看有什么用'
                })
                .then((res) => {
                console.log(res)
                })
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
            
        }),
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_top: DESC','property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.list = [];
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/post/list/for/subject',this.params);
            this.pageComplete = true;
            this.listLoading = false;
           
            if( result.code == 0 ){
          
                if( this.params.offset == 1 ){
                    this.list = [];
                }
                var inflowAdv = inflowAdvConvert(result.data.items, 'topic', '3261');
                this.list = this.list.concat(inflowAdv);
                console.log(this.list)
                this.hasMore = this.params.offset < result.data.pageTotal;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.mrg-btm20{margin-bottom: 20px;;}
.tab-style{
    display: flex; align-items: center; justify-content: center; margin-bottom: 15px !important; z-index: 10; margin-bottom: 30px;
    .item{
        font-size: 14px; line-height: 24px; margin-right: 40px; color: #666; user-select: none; cursor: pointer;
        &:hover{color: #111;}
        &:last-child{margin-right: 0;}
        &.active{
            position: relative; font-weight: bold; z-index: 10; font-size: 18px; color: #111;
            /* &:after{
                position: absolute; content: ''; z-index: -1; left: 0; bottom: 0; right: 0; height: 7px; background: #fa4a83;
            } */
        }
    }

}
@media screen and (min-width:768px){
    .tab-style{
        display: flex; align-items: center; justify-content: center; margin-bottom: 20px !important;
        .item{
            font-size: 18px; line-height: 37px; margin-right: 40px; user-select: none; cursor: pointer;
            &:last-child{margin-right: 0;}
            &.active{
                position: relative; font-weight: bold; font-size: 26px;
                /* &:after{
                    position: absolute; content: ''; left: 0; bottom: 0; right: 0; height: 7px; background: #fa4a83;
                } */
            }
        }

    }
}
.post-list{
    
    background: #FFF3E1; padding: 25px 15px; border-radius: 20px;
    .iner-warp{
        background: #fff; border-radius: 20px; padding: 25px 15px 0; overflow: hidden;
    }
}
/**参加活动按钮 */
.join-play{
    position: fixed; z-index: 100; right: 30px; bottom: 70px; 
    .box{display: none;}
    .media-box{
        position: relative;
        width: 76px; height: 76px; border-radius: 50%; background: #ffe500; display: flex; flex-direction: column; justify-content: center; align-items: center; color: #000; font-size: 14px; line-height: 20px;
        &:after{content: ''; position: absolute; left: 3px;top: 3px; width: 100%; height: 100%; background: #ff821d; border-radius: 50%;  z-index: -1;}
    }
    
    
}
@media screen and (min-width:768px){
    .join-play{
        right: 0; left: 0;
        .box{width:auto; max-width: 800px; margin: 0 auto; height: 50px; font-size: 20px;  border-radius: 4px;  display: block;
            a{height: 50px; display: flex; align-items: center; background: #FB8B31; border-radius: 10px; justify-content: center; color: #fff;
                div{margin: 0 5px 0 0 ;}
                &:hover{color: #f9fb67;}
            }
            i{font-size: 26px;}
        }
        .media-box{display: none;}
    }
}

.loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}

@media screen and (max-width:768px){
    .white-space{height: 30px !important;}
}
</style>